<template>
    <div>
        <modal
            name="modal-lateral"
            height="auto"
            @before-close="ClosedModal"
            class="modalLateral"
            v-bind:click-to-close="false"
        >
            <div class="card">
                <button @click="closeModal" class="closeIcon" style="width: 50px">
                    <span></span>
                </button>
                <Loader v-if="isLoading" class="bgloading"></Loader>
                <slot></slot>
            </div>
        </modal>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import Loader from "@/components/shared/Loader";
import "@/components/themeModalLateral/styles.css";
export default {
    name: "modalLateral",
    components: {
        Loader,
    },
    props: {
        dataModal: {
            type: [Object],
            default: () => {},
        },
    },
    data () {
        return {
            title: "",
            nameComponent: "",
            isLoading: false,
        };
    },
    methods: {
        closeModal() {
            this.$store.commit("setCloseModal", false);
            var elem = document.querySelector(".v--modal");
            elem.classList.add("closed");
            this.$modal.hide("modal-lateral");
        },
        closeModal2() {
            var elem = document.querySelector(".v--modal");
            elem.classList.add("closed");
            this.$modal.hide("modal-lateral");
        },
        ClosedModal() {
            this.nameComponent = "";
        },
    },
    watch: {
        openModal: function () {
            // console.log("openModal", this.openModal);
            this.nameComponent = this.openModal.component;
            this.title = this.openModal.data.title;
            if (this.openModal.show) {
                this.$modal.show("modal-lateral");
            } else {
                this.closeModal2();
            }
            if (window.innerWidth <= 600) {
                // console.log("modal en responsive");
                let elem = document.querySelector(".page-wrapper");
                if (elem && this.openModal.show) {
                    elem.style.zIndex = "100";
                } else if (elem && !this.openModal.show) {
                    elem.style.zIndex = "1";
                }
            }
        },
        LoadingModal: function () {
            this.isLoading = this.LoadingModal;
        },
    },
    computed: {
        ...mapGetters({
            openModal: "getOpenModal",
            LoadingModal: "getLoadingModal",
        }),
    },
};
</script>
<style lang="css" scoped>
.bgloading {
    background-color: rgb(255 255 255 / 50%);
}
.closeIcon {
    right: 1px;
    top: 2px;
    height: 40px;
    width: 40px;
}
.closeIcon span:before {
    width: 40px;
}
.closeIcon span:after {
    width: 40px;
}
</style>
